import { render, staticRenderFns } from "./onebox-allbusinessinboxsystem.vue?vue&type=template&id=d7ffa2d4&scoped=true&"
import script from "./onebox-allbusinessinboxsystem.vue?vue&type=script&lang=js&"
export * from "./onebox-allbusinessinboxsystem.vue?vue&type=script&lang=js&"
import style0 from "./onebox-allbusinessinboxsystem.vue?vue&type=style&index=0&id=d7ffa2d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7ffa2d4",
  null
  
)

export default component.exports